<template lang="html">
  <v-container fluid class="px-sm-10">
    <v-row>
      <v-col cols="auto" class="headline">Journal log</v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card :loading="loading">
          <base-items storeModule="zreports" :filter="reportsFilter" @items="zreports = $event" @state="zreportState = $event"></base-items>

          <v-card-title>
            Points Of Sale
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-for="pos in pointsOfSaleOptions"
                :key="pos.id"
                cols="auto"
              >
                <v-chip
                  :color="pos.selected ? 'primary' : 'primary'"
                  :outlined="!pos.selected"
                  @click="selectedPos = pos.id"
                >
                  {{pos.name}}
                </v-chip>
              </v-col>
              <v-col
                cols="auto"
                v-if="zreportState.loading"
              >
                <v-progress-circular
                 indeterminate
                 color="primary">
                </v-progress-circular>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-title>
            Filter
            <v-spacer/>
            <v-btn color="primary" :loading="loading" @click="applyFilter">Apply</v-btn>
          </v-card-title>

          <v-card-text>

            <h2>Date &amp; time</h2>

            <v-row>
              <v-col cols="12" sm="6">
                <v-row>
                  <v-col cols="12" sm="6">
                    <date-input v-model="dateFrom" :max="today" label="Date from"></date-input>
                  </v-col>
                  <v-col cols="12" sm="6" class="mt-n5 mt-sm-0 mb-3 mb-sm-0">
                    <time-input
                      class=""
                      v-model="timeFrom"
                      label="Time from"
                      clearable
                      :disabled="!dateFrom"
                      :messages="dateFrom ? '' : 'Requires a date'"
                    ></time-input>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <date-input v-model="dateTo" :max="today" label="Date to"></date-input>
                  </v-col>
                  <v-col cols="12" sm="6" class="mt-n5 mt-sm-0">
                    <time-input
                      class=""
                      v-model="timeTo"
                      label="Time to"
                      clearable
                      :disabled="!dateTo"
                      :messages="dateTo ? '' : 'Requires a date'"
                    ></time-input>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" sm="3">
                <v-row>
                  <v-radio-group label="Output format" v-model="output_type">
                    <v-radio
                      label="XML"
                      value="xml"
                    ></v-radio>
                    <v-radio label="JSON"
                      value="json">
                    </v-radio>
                    <v-radio label="In page"
                      value="page">
                    </v-radio>
                  </v-radio-group>
                </v-row>
              </v-col>
              <v-col cols="6" sm="3">
                <v-row>
                  <v-col cols="6">
                    <v-checkbox
                      v-model="validate"
                      label="Validate"
                      messages="Validate the output against XSD files"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-checkbox
                      class="body-2 mt-0"
                      label="Fetch all point of sales"
                      v-model="fetchAllZReports"
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </v-card-text>

          <v-card-actions>
            <v-btn text @click="reset">Reset</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <div class="margin-journal">
      <JournalJson ref="journalJson" :json="journalJson" />
      <v-fab-transition>
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              dark
              fixed
              right
              bottom
              class="copy-btn"
              @click="copyToClipboard"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Copy data</span>
        </v-tooltip>
      </v-fab-transition>

      <v-fab-transition>
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              dark
              fixed
              right
              bottom
              class="scroll-btn"
              @click="scrollToTop"
            >
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
          </template>
          <span>Scroll to top</span>
        </v-tooltip>
      </v-fab-transition>
    </div>

    <v-dialog v-model="showModal" persistent max-width="400px">
        <v-card>
          <v-card-title>Error</v-card-title>
          <v-card-text>
            <div v-html="errorMessage"></div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="showModal = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </v-container>
</template>

<script>
import {apiUrl} from '@dynapp/wc-api-generic'
import {BaseItems} from 'dync-baseitem'
import {DateInput, TimeInput} from 'dync-datetime';
import JournalJson from '../components/JournalJson.vue';
import moment from 'moment-timezone'
import axios from 'axios';

export default {
  data () {
    return {
      moment,
      today: moment().format('YYYY-MM-DD'),
      dateFrom: this.calculateDateFrom(),
      dateTo: this.calculateDateTo(),
      timeFrom: '00:00',
      timeTo: '00:00',
      output_type: 'xml',
      validate: true,
      journalJson: {},
      selectedPos: 'all',
      zreports: [],
      zreportState: {},
      fetchAllZReports: false,
      showModal: false,
      errorMessage: '',
    };
  },
  watch: {
    dateFrom (val) {
      if (!val) {
        this.timeFrom = '';
      }
    },
    dateTo (val) {
      if (!val) {
        this.timeTo = '';
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.isLoadingFor('journal.read');
    },
    pointsOfSale () {
      var unique_poss = {};
      var reports = this.$store.getters['zreports/items']
      return reports.map((zreport) => zreport.point_of_sale)
      .filter((pos) => !!pos)
      .sort()
      .filter((pos) => {
        if (unique_poss[pos] !== undefined) {
          return false;
        }
        unique_poss[pos] = true;
        return true;
      })
      .map((pos) => {
        return {
          id: pos,
          name: (pos.match(/FTP\d{3}/) || [''])[0] || pos
        };
      });
    },
    pointsOfSaleOptions () {
      var options = [{id: 'all', name: 'All'}, ...this.pointsOfSale];
      options = options.map((option) => {
        option = {...option};
        option.selected = option.id == this.selectedPos;
        return option;
      });
      return options;
    },
    reportsFilter() {
      var result = {}
      if (!this.fetchAllZReports) {
        result.greaterThan = [
          ['created_at', moment().subtract(1, 'months').tz('Europe/Stockholm').format('YYYY-MM-DD HH:mm:ss')]
        ];
      }
      if (this.selectedPos != 'all') {
        result.keyValue = [
          ['point_of_sale', this.selectedPos]
        ];
      }
      return result;
    },
  },
  methods: {
    validTime (value) {
      return moment(value, 'HH:mm', true).isValid();
    },
    applyFilter () {
      this.journalJson = {};
      this.$store.commit('startLoading', 'journal.read');
      var selectedPosArray = this.selectedPos === 'all' ? this.pointsOfSale.map(a => a.id) : [this.selectedPos];
      axios.post(apiUrl({'dataObject': 'dync-appshop-journal'}, ''),{
        responseType: 'blob',
        start: ''.concat(this.dateFrom, 'T', this.timeFrom, ':00'),
        end: ''.concat(this.dateTo, 'T', this.timeTo, ':00'),
        selPos: selectedPosArray,
        type: this.output_type,
        validate: this.validate ? 'true' : 'false'
      }).then(
        (response) => {
          this.$store.commit('endLoading', 'journal.read');

          if (this.output_type === 'xml') {
            this.downloadData(response.data);
          } else if (this.output_type === 'json') {
            this.downloadData(JSON.stringify(response.data, null, 4));
          } else {
            this.journalJson = response.data;
          }
        },
      ).catch((error) => {
        this.$store.commit('endLoading', 'journal.read');
        this.errorMessage = 'Error';
        if( error.response ) {
          this.errorMessage = this.formatErrorMessage(error.response.data);
          this.showModal = true;
        }
      });
    },
    formatErrorMessage(data) {
      if (data && typeof data === "object" && 'error' in data && data.error.includes('One of')) {
        var message = data.error;
        const regex = /:\w+/g;
        const matches = message.match(regex).map(m => m.slice(1));

        const formattedMessage = `
          Invalid content found: ${matches[0]}<br>
          Expected one of: ${matches.slice(1).join(', ')}
        `;
        return formattedMessage.trim();
      }
      if (data && typeof data === "object" && 'error' in data) {
        return data.error;
      }
      return data;
    },
    downloadData(data) {
      // Create a Blob from the response data
      const blob = new Blob([data], { type: 'application/xml' });

      // Create a hidden anchor element and set the download attribute with the desired file name
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'fasttrack-journal-'.concat(this.dateFrom, '_', this.dateTo, '.', this.output_type);
      link.style.display = 'none';
      document.body.appendChild(link);

      // Trigger the download and remove the anchor element afterwards
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    },
    calculateDateFrom() {
      const date = new Date(); // Get the current date
      date.setDate(date.getDate() - 7); // Subtract 7 days
      return this.formatDate(date);
    },
    calculateDateTo() {
      const date = new Date(); // Get the current date
      date.setDate(date.getDate() - 1); // Subtract 1 day
      return this.formatDate(date);
    },
    formatDate(date) {
      // Format the date as 'YYYY-MM-DD'
      const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      return formattedDate;
    },
    reset () {
      this.journalJson = {};
      this.dateFrom = this.calculateDateFrom();
      this.dateTo = this.calculateDateTo();
      this.timeFrom = '00:00';
      this.timeTo = '00:00';
      this.output_type = 'xml';
      this.validate = true;
      this.selectedPos = 'all';
    },
    copyToClipboard() {
      const text = this.$refs.journalJson.getFormattedText(this.journalJson);
      const textarea = document.createElement('textarea');
      textarea.textContent = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted () {
  },
  components: {
    TimeInput,
    DateInput,
    JournalJson,
    BaseItems
  }
}
</script>

<style scoped lang="css">
.margin-journal {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}
.scroll-btn {
  right: 80px;
}
</style>
